import { render } from "./tasksMaster.vue?vue&type=template&id=36a9d8b4&scoped=true"
import script from "./tasksMaster.vue?vue&type=script&lang=js"
export * from "./tasksMaster.vue?vue&type=script&lang=js"

import "./tasksMaster.vue?vue&type=style&index=0&id=36a9d8b4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36a9d8b4"]])

export default __exports__